import paletteJiraBoard from "../../../../src/pages/foundations/color/color-palette/_assets/palette-jira-board-light.png";
import paletteNeutralMapping from "../../../../src/pages/foundations/color/color-palette/_assets/palette-neutral-mapping.png";
import paletteSaturatedMapping from "../../../../src/pages/foundations/color/color-palette/_assets/palette-saturated-mapping.png";
import { ColorPaletteRamps } from '@af/design-system-docs-ui';
import { ColorPaletteDedication } from '@af/design-system-docs-ui';
import * as React from 'react';
export default {
  paletteJiraBoard,
  paletteNeutralMapping,
  paletteSaturatedMapping,
  ColorPaletteRamps,
  ColorPaletteDedication,
  React
};